export default __webpack_public_path__ + "static/media/e-other.9470ce56.png";